import { ContainedTextField } from '../../../Form/FinalForm/Contained/ConainedTextField';
import { composeValidators, required, vinLength } from '../../../../utils/validators';
import { UploadType } from 'services/listerUploadVehicle/v2';
import { useGetVinInfoQuery } from 'services/api/upload-vehicle';
import styled from 'styled-components';
import { useField } from 'react-final-form';
import { useEffect, useState } from 'react';

const upper = (value: string) => value && value.toUpperCase();

type Props = {
  type: UploadType;
};

const VinNotFound = styled.div`
  background: #e933231a;
  padding: 1px 12px;
  border-bottom: 1px solid #af2930;
  margin-top: -8px;
  color: #af2930;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
`;

const VinNotFoundComponent = ({ message }) => <VinNotFound>{message}</VinNotFound>;

export const VinField = ({ type }: Props) => {
  const {
    input: { value: vin },
    meta: { error }
  } = useField('vin');

  const { data } = useGetVinInfoQuery(vin, {
    skip: type === 'edit' || !vin || !!error
  });

  const { input: manualUploadInput } = useField('manual_upload');
  const { input: reuploadInput } = useField('is_reupload');

  useEffect(() => {
    if (!data) return;
    const { uploadType, hasDuplicate } = data;
    if (uploadType === 'manual') {
      manualUploadInput.onChange(true);
    } else {
      manualUploadInput.onChange(false);
    }

    if (hasDuplicate) {
      reuploadInput.onChange(true);
    } else {
      reuploadInput.onChange(false);
    }
  }, [data]);

  const showAdditionalComponent = !error && !!data?.statusMessage;

  return (
    <ContainedTextField
      validate={composeValidators(required, vinLength)}
      label="VIN"
      name="vin"
      parse={upper}
      AdditionalComponent={
        showAdditionalComponent ? () => <VinNotFoundComponent message={data?.statusMessage} /> : undefined
      }
    />
  );
};
